<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('integralShopRule.queryCondition') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="integralShopRuleInfo.conditions.ruleName"
            :placeholder="$t('integralShopRule.ruleNamePlaceholder')" clearable />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryIntegralShopRuleMethod">
            <i class="el-icon-search"></i>
            {{ $t('integralShopRule.query') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('integralShopRule.ruleTitle') }}</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddIntegralShopRuleModal">
          {{ $t('integralShopRule.add') }}
        </el-button>
      </div>

      <el-table :data="integralShopRuleInfo.integralShopRules" border style="width: 100%">
        <el-table-column prop="ruleId" :label="$t('integralShopRule.id')" align="center" width="100" />
        <el-table-column prop="ruleName" :label="$t('integralShopRule.ruleName')" align="center" />
        <el-table-column prop="money" :label="$t('integralShopRule.money')" align="center" />
        <el-table-column prop="amount" :label="$t('integralShopRule.amount')" align="center" />
        <el-table-column prop="createTime" :label="$t('integralShopRule.createTime')" align="center" />
        <el-table-column :label="$t('integralShopRule.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditIntegralShopRuleModel(scope.row)">
              {{ $t('integralShopRule.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteIntegralShopRuleModel(scope.row)">
              {{ $t('integralShopRule.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @current-change="handleCurrentChange" :current-page="integralShopRuleInfo.conditions.page"
        :page-size="integralShopRuleInfo.conditions.row" layout="total, prev, pager, next"
        :total="integralShopRuleInfo.total" style="margin-top: 20px;" />
    </el-card>

    <add-integral-shop-rule ref="addIntegralShopRule" @refresh="_queryIntegralShopRuleMethod()" />
    <edit-integral-shop-rule ref="editIntegralShopRule" @refresh="_queryIntegralShopRuleMethod()" />
    <delete-integral-shop-rule ref="deleteIntegralShopRule" @refresh="_queryIntegralShopRuleMethod()" />
  </div>
</template>

<script>
import { listIntegralShopRule } from '@/api/shop/integralShopRuleApi'
import { getShopId } from '@/api/shop/shopApi'
import AddIntegralShopRule from '@/components/shop/addIntegralShopRule/addIntegralShopRule'
import EditIntegralShopRule from '@/components/shop/editIntegralShopRule/editIntegralShopRule'
import DeleteIntegralShopRule from '@/components/shop/deleteIntegralShopRule/deleteIntegralShopRule'

export default {
  name: 'IntegralShopRule',
  components: {
    AddIntegralShopRule,
    EditIntegralShopRule,
    DeleteIntegralShopRule
  },
  data() {
    return {
      integralShopRuleInfo: {
        integralShopRules: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          ruleName: '',
          shopId: '',
          money: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listIntegralShopRules(1, 10)
  },
  methods: {
    async _listIntegralShopRules(page, rows) {
      this.integralShopRuleInfo.conditions.page = page
      this.integralShopRuleInfo.conditions.row = rows
      let shopId = await getShopId()
      this.integralShopRuleInfo.conditions.shopId = shopId

      try {
        const res = await listIntegralShopRule(this.integralShopRuleInfo.conditions)
        this.integralShopRuleInfo.integralShopRules = res.data
        this.integralShopRuleInfo.total = res.total
        this.integralShopRuleInfo.records = res.records
      } catch (error) {
        console.error('获取积分规则列表失败:', error)
      }
    },
    _openAddIntegralShopRuleModal() {
      this.$refs.addIntegralShopRule.open()
    },
    _openEditIntegralShopRuleModel(row) {
      this.$refs.editIntegralShopRule.open(row)
    },
    _openDeleteIntegralShopRuleModel(row) {
      this.$refs.deleteIntegralShopRule.open(row)
    },
    _queryIntegralShopRuleMethod() {
      this._listIntegralShopRules(1, 10)
    },
    handleCurrentChange(val) {
      this._listIntegralShopRules(val, this.integralShopRuleInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>